import React from 'react';

type Props = { children: React.ReactNode; mono?: boolean; tone?: 'danger' | 'warning' };

const FigureSub: React.FC<Props> = ({ children, mono = false, tone }) => (
    <div className="bd-fig-sub" data-mono={mono || undefined} data-tone={tone} title={typeof children === 'string' ? children : undefined}>{children}</div>
);

export default FigureSub;
